export class OverlayManager {
  private overlayContainer: HTMLDivElement;
  private timeout: number | NodeJS.Timeout;

  constructor(overlayContainer: HTMLDivElement) {
    this.overlayContainer = overlayContainer;
  }

  /**
   * Show the provided overlay.
   * @param {Function} getOverlay Overlay to be shown.
   * @param {object} props Properties to be parsed on to overlay call.
   */
  showOverlay(getOverlay: (props?: any) => HTMLDivElement, props?: Record<string, any>) {
    const overlay = getOverlay(props);
    const currentOverlay = this.overlayContainer.querySelector(`#${overlay.id}`) as HTMLDivElement;

    if (currentOverlay) {
      this.overlayContainer.replaceChild(overlay, currentOverlay);
    } else {
      this.overlayContainer.appendChild(overlay);
    }
  }

  showOverlayFor(
    getOverlay: (props?: any) => HTMLDivElement,
    props?: Record<string, any>,
    timeout: number = 24_000
  ) {
    clearTimeout(this.timeout);
    this.showOverlay(getOverlay, props);
    this.timeout = setTimeout(() => {
      this.hideOverlay();
    }, timeout);
  }

  /**
   * Removes the overlays.
   */
  hideOverlay = () => {
    this.overlayContainer.querySelectorAll('div').forEach(element => element.remove());
  };

  /**
   * Static function to create overlay div element.
   */
  static createOverlayElement = (id: string, className: string) => {
    const div = document.createElement('div');
    div.id = id;
    div.className = className;
    return div;
  };
}

export { gen1Deprecated } from './gen1Deprecated';
export { error } from './error';
